/* eslint-env browser */
/* eslint no-restricted-syntax: 0 */
/* eslint no-prototype-builtins: 0 */
class AUUrlHandler {
  constructor(onPopState, useHistory = true) {
    this.useHistory = useHistory;

    if (typeof onPopState === 'function') {
      window.onpopstate = (event) => {
        onPopState(event);
      };
    }
  }

  static getQuery(index = 1) {
    return window.location.search.substring(index); // 1 = without ?
  }

  static parse() {
    const query = AUUrlHandler.getQuery();
    if (query === '') {
      return null;
    }
    const objString = `{"${query.replace(/&/g, '","').replace(/=/g, '":"')}"}`;
    return JSON.parse(objString, (key, value) => (key === '' ? value : decodeURIComponent(value)));
  }

  static serialize(obj) {
    const str = [];
    for (const p in obj) {
      if (obj.hasOwnProperty(p) && obj[p] !== '') {
        str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
      }
    }
    return str.join('&');
  }

  set(query, append = true, title = '') {
    const { key, value } = query;

    const current = AUUrlHandler.parse() || {};
    current[key] = value;

    const { location: { protocol, host, pathname } } = window;
    let next = `?${AUUrlHandler.serialize(current)}`;
    if (next === '?') {
      next = `${protocol}//${host}${pathname}`;
    } else {
      next = `${pathname}${next}`;
    }
    if (this.useHistory) {
      if (append) {
        window.history.pushState('', title, next);
      } else {
        window.history.replaceState('', title, next);
      }
    } else {
      window.location.search = next;
    }
  }
}

export default AUUrlHandler;
